import { mapState } from 'vuex';
import multiSearchMixin from '@/mixins/multiSearchVirtualDevices';
export default {
  name: 'CoreVirtualDeviceDialogCreateView',
  mixins: [multiSearchMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    editItem: {
      type: Object,
      default: () => ({})
    }
  },
  data: function () {
    return {
      selectedAccount: null,
      viewTitle: '',
      viewDescription: ''
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    saveDisabled() {
      // https://digimondo.atlassian.net/browse/RD-6971
      // only requires account and title, search-items are optional - to create view of all devices of an account
      return !this.selectedAccount || !this.viewTitle;
    },
    filteredSearchTypes() {
      return this.searchTypes.filter(type => type.param !== 'health' && type.param !== 'zone');
    }
  },
  watch: {
    loadingDataDone: {
      handler: function (loadingDone) {
        if (loadingDone) {
          this.initEditItem();
        }
      },
      immediate: true
    }
  },
  methods: {
    initEditItem() {
      this.viewTitle = this.editItem.title || '';
      this.viewDescription = this.editItem.description || '';
      this.selectedAccount = this.editItem.tenantId || null;
      const search = ((this.editItem || {}).viewConfig || {}).searchItems || [];
      const t = search.map(item => {
        if (item.variable === 'deviceType') {
          const devices = this.searchTypes.find(type => type.param === 'deviceType').items;
          return {
            param: item.variable,
            search: {
              value: item.search,
              text: devices.find(device => device.value === item.search).text
            }
          };
        }
        if (item.variable === 'operationalStatus') {
          return {
            param: item.variable,
            search: {
              value: item.search,
              text: this.operationalStatus[item.search]
            }
          };
        }
        return {
          param: item.variable,
          search: item.search
        };
      });
      this.searchItems = t;
      this.searchOperator = (this.editItem.viewConfig || {}).searchOperator;
    },
    searchUpdated(searchItems, operator) {
      this.searchItems = searchItems; // defined in multiSearchMixin
      this.searchOperator = operator; // defined in multiSearchMixin
    },
    close() {
      // reset values on dialog close
      this.selectedAccount = null;
      this.viewTitle = '';
      this.viewDescription = '';
      this.searchItems = []; // defined in multiSearchMixin

      this.$emit('close');
    },
    createRequestOptions() {
      return {
        tenantId: this.selectedAccount,
        title: this.viewTitle,
        description: this.viewDescription,
        // meta: null, // meta is included in the docs, but API throws 400 when used
        viewConfig: {
          searchItems: this.searchItems.map(item => ({
            variable: item.param,
            key: item.key,
            // support item.search.value === null, so do not simply have a >search.value || search< expression
            search: (item.search || {}).value === undefined ? item.search : item.search.value
          })),
          searchOperator: this.searchOperator,
          filters: [{
            type: 'tenantIds',
            ids: [this.selectedAccount]
          }],
          options: null
        },
        meta: {}
      };
    },
    update() {
      const params = this.createRequestOptions();
      params.id = this.editItem.id;
      this.$emit('update', params);
      this.close();
    },
    save() {
      const params = this.createRequestOptions();
      this.$emit('save', params);
      this.close();
    }
  }
};